module.exports = {"360404001":"沙河街道","360404002":"狮子街道","360404003":"城门街道","360404101":"马回岭镇","360404102":"江洲镇","360404103":"城子镇","360404104":"港口街镇","360404105":"新合镇","360404200":"永安乡","360404201":"涌泉乡","360404202":"新塘乡","360404204":"岷山乡","360404403":"沙河经济技术开发区","360404501":"新洲垦殖场","360404502":"赛城湖水产场","360404503":"岷山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360404.json
// module id = 1379
// module chunks = 0